<template>
  <a-popover trigger="click" placement="bottomRight" :visible="showVisible"
             @visibleChange="()=>{showVisible=!showVisible}">
    <template slot="content" >
      <div style="cursor: pointer;padding: 5px 0;border-bottom: 1px solid #001529"  @click="gotoBase()">GB主页</div>
      <div style="cursor: pointer;padding: 5px 0;" @click="outLogin()">退出登录</div>
    </template>
    <div style="display: flex;align-items: center;cursor: pointer" v-if="user.name">
      <div :style="{background:color }"
           style="width: 40px;height: 40px;line-height: 40px;text-align:center;border-radius: 20px;font-size: 20px;font-weight: bolder;margin:0 10px">
        {{user.name.substr(0,1)}}
      </div>
      <div style="display: flex;flex-flow: column;line-height: normal;text-align: center">
        <div style="font-size: 16px;margin-bottom: 3px;">{{user.name}}</div>
        <div style="font-size: 14px;background: #87d068;border-radius: 5px;">{{user.group_name}}</div>
      </div>
    </div>
  </a-popover>
</template>

<script>
export default {
  name: "UserInfoPanel",
  props: ["userInfo"],
  data(){
    return {
      user:{},
      showVisible:false,
      color:'rgba('+Math.floor(Math.random()*256)+','+Math.floor(Math.random()*256)+','+Math.floor(Math.random()*256)+',1)'
    }
  },
  mounted() {
    this.user = this.userInfo
  },
  methods:{
    outLogin(){
      localStorage.setItem("user_id","")
      localStorage.setItem("user_token","")
      window.location = '/'
    },
    gotoBase(){
      window.location = 'https://home.gamebrain.io'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/UserInfoPanel.vue